import { roundToTwo } from 'common/helpers/round-to-two.helper';
import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { TInputs } from '../forms/dimensions/types';

type TDirtyFields = Partial<
  Readonly<{
    width?: boolean | undefined;
    length?: boolean | undefined;
    layingType?: boolean | undefined;
    area?: boolean | undefined;
  }>
>;

const DEFAULT_ZERO_VALUE = '0';

export const getUpdatedConfigurationParameters = (inputParams: TInputs, dirtyFields: TDirtyFields) => {
  let areaValue: string;
  let width: string;
  let length: string;

  const isWidthAndLengthDirty = dirtyFields.width && dirtyFields.length;
  const isAreaDirty = dirtyFields.area;

  if (isWidthAndLengthDirty) {
    width = inputParams.width || DEFAULT_ZERO_VALUE;
    length = inputParams.length || DEFAULT_ZERO_VALUE;
    areaValue = String(+width * +length);
  } else if (isAreaDirty && inputParams.area) {
    areaValue = inputParams.area;
    width = DEFAULT_ZERO_VALUE;
    length = DEFAULT_ZERO_VALUE;
  } else {
    width = inputParams.width || DEFAULT_ZERO_VALUE;
    length = inputParams.length || DEFAULT_ZERO_VALUE;
    areaValue = inputParams.area || DEFAULT_ZERO_VALUE;
  }

  const layingTypeValue = inputParams.layingType ?? LayingType.horizontal;

  return [
    {
      key: 'area',
      value: String(roundToTwo(+areaValue)),
    },
    {
      key: 'width',
      value: width,
    },
    {
      key: 'length',
      value: length,
    },
    {
      key: 'layingType',
      value: layingTypeValue,
    },
  ];
};
